import React, { useState, useEffect } from "react";
import axiosInstance, { handleApiError } from "../../services/axiosService";
import { toastSuccess } from "../../utils/toastUtils";
import AppLeftSideBar from "../../components/SideBar/AppLeftSideBar";
import { useParams } from "react-router-dom";

const MetricsSection = () => {
  const params = useParams();
  const [metrics, setMetrics] = useState();

  const fetchAllMetrics = async () => {
    // const response = axios.get(api/v1/location/app/${getStorageItem("Zino_app_id"))
    try {
      const { data, message } = await axiosInstance.get(`/metrics`);
      setMetrics(data);
      toastSuccess(message);
    } catch (error) {
      handleApiError(error);
    }
  };

  useEffect(() => {
    fetchAllMetrics();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="application_container">
        <AppLeftSideBar type={params.orgId ? "app" : "org"} />
        <div className="dashboard_outer_section">
          <section className="metrics_container">
            <table>
              <thead className="metrics_table_header">
                <tr>
                  <td>AppID</td>
                  <td>State Machine</td>
                  <td>Entity</td>
                </tr>
              </thead>
              <tbody>
                {metrics ? (
                  metrics.map((mat, index) => (
                    <tr key={index}>
                      <td>{mat.app_id}</td>
                      <td>
                        <table>
                          <thead>
                            <tr>
                              <td>State Machine Name </td>
                              <td>Total Instance</td>
                            </tr>
                          </thead>
                          <tbody>
                            {mat ? (
                              mat.state_machine.map((mats, index) => (
                                <tr key={index}>
                                  <td>{mats.sm_name}</td>
                                  <td>{mats.instance_count}</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td>No StateMachine Instance Found</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </td>
                      <td>
                        <table style={{ marginTop: "20px" }}>
                          <thead>
                            <tr>
                              <td>Entity Name </td>
                              <td>Total Instance</td>
                            </tr>
                          </thead>
                          <tbody>
                            {mat ? (
                              mat.entity.map((mate, index) => (
                                <tr key={index}>
                                  <td>{mate.sm_name}</td>
                                  <td>{mate.instance_count}</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td>No Entity Instance Found</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td>No Metrics Data Found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </section>
        </div>
      </div>
    </>
  );
};
export default MetricsSection;
